import { BaseService } from '@common/http-layer/service/base.service'

import type { IGokollabGenerateLeadPayload, IGokollabGenerateLinkResponse } from '../types/invitation'

/**
 * Gokollab Invitations service — handles affiliate link generation for Gokollab (white-label) flow
 * Base URL: GOKOLLAB_SERVER_URL
 * Endpoints:
 *   POST /{locationId}/affiliates/generate-link
 *   POST /{locationId}/affiliate-members/generate-lead
 */
export class GokollabInvitationsService extends BaseService {
  constructor() {
    super({
      baseURL: 'GOKOLLAB_SERVER_URL',
      basePath: '',
      serviceName: 'GokollabInvitationsService',
    })
  }

  async generateInvitationLink(locationId: string, groupId: string): Promise<IGokollabGenerateLinkResponse> {
    const { data } = await this.post<IGokollabGenerateLinkResponse>(
      `/${locationId}/affiliates/generate-link`,
      { locationId, entityId: groupId },
      { locationId, groupId }
    )
    return data
  }

  async generateLead(locationId: string, payload: IGokollabGenerateLeadPayload): Promise<unknown> {
    const { data } = await this.post<unknown>(`/${locationId}/affiliate-members/generate-lead`, payload, {
      locationId,
      groupId: payload.groupId,
    })
    return data
  }
}
